module.exports = __webpack_public_path__ + "img/workout-notebook_B095Q7XW5X.81595932.jpg";